common:
  comments:
    allComments: All Comments ({total})
    author: Author
    createSuccess: Comment sent successfully
    delete: Delete
    deleteSuccess: Comment deleted successfully
    headFor: Please go to {action} to share your thoughts…
    hottest: Hottest
    latest: Latest
    login: Login
    removeConfirm: Are you sure you want to delete this comment?
    reply: Reply
    replySuccess: Reply sent successfully
    send: Send
    support: Like
    supportSuccess: Operation successful
    tips: Share your thoughts, ask questions, or join the discussion!
    viewAllReply: View all {total} replies
  communityCard:
    popup:
      cancel: Remind me later
      invite: Invite you to join the community
      join: Join Us
      view: View details
  header:
    login: Log in
    nav1: Home
    nav2: Trending
    new:
      menu1: Community Center
      menu2: Add Repository
      menu4: Add Organization
      menu5: New Draft
    notice:
      tooltip: Go to AtomGit message center
    register: Sign up
    search:
      tooltip: Search
    user:
      menu1: Profile
      menu10: Sign out
      menu2: Repositories
      menu3: Organizations
      menu4: Merge Requests
      menu5: Issues
      menu6: Starred
      menu7: Personal center
      menu8: Community settings
      menu9: Help Documents
  languageName: English
  platform:
    name: 'Platform: {platform}'
  prismjs:
    copy: Copy
    copyError: Copy Error!
    copySuccess: Copied!
  search:
    hotTag:
      title: Hot Tag
    index:
      nodata: No Data
      title: Search Result
    inputPlaceholder: What are you searching for…?
    journalism:
      title: Journalism
    order:
      fork: Fork
      hottest: Hottest
      member: Member
      newest: Newest
      star: Star
    organization:
      title: Organization
    repository:
      title: Repository
      update: Update
    searchResult: '{total} Results'
    tag:
      number1: '{total} Journalism'
      number2: '{total} Repository'
      number3: '{total} Organization'
      title: Tag
  searchDialog:
    clear: Clear
    content: Content
    history: History
    inputPlaceholder: What are you searching for…?
    searchType1: Journalism
    searchType2: Repository
    searchType3: Organization
    searchType4: Tag
  tag:
    index:
      title: Tag
    journalism:
      title: Journalism
    organization:
      title: Organization
    repository:
      title: Repository
  websiteDescription:
    default: ''
  websiteKeywords:
    default: ''
  websiteTitle:
    default: OpenAtom
home:
  '404':
    goBack: Back
    notFound: Page Not Found
  column:
    index:
      infoTotal: 'Total: {total}'
      like: 'Like: {total}'
      title: Column
      view: 'View: {total}'
  common:
    all: All
    carousel:
      changeTo: Switch to pictures {index}
      jumpToUrl: Jump to {url}
    emptyContent: No Data
    follow:
      cancel: Unfollow
      ok: Follow
    prime: Pinned
  component:
    noticeBar:
      close: Close
    pagination:
      goto: to {component}
      ok: Confirm
    popconfirm:
      cancel: Cancel
      ok: OK
  content:
    title1: Trending
    title2: News
    title3: Resources
    title4: Organizations
    title5: News
  explore:
    author:
      button1: Follow
      button2: Followed
      button3: Message
      inputPlaceholder: Message...
      messageError: Error
      messageSuccess: Success
      number1: Article
      number2: Following
      number3: Follower
      sendButton1: Send
      sendButton2: Cancel
      sendMessage: Send Message
    comments:
      allComments: All Comments ({total})
      author: Author
      createSuccess: Comment sent successfully
      delete: Delete
      deleteSuccess: Comment deleted successfully
      headFor: Please go to {action} to share your thoughts…
      hottest: Hottest
      latest: Latest
      login: Login
      removeConfirm: Are you sure you want to delete this comment?
      reply: Reply
      replySuccess: Reply sent successfully
      send: Send
      support: Like
      supportSuccess: Operation successful
      tips: Share your thoughts, ask questions, or join the discussion!
      viewAllReply: View all {total} replies
    developer:
      empty: No Data
      title: Developer
    journalism:
      comment: Comment
      copyRight1: >-
        Copyright Notice: This article is originally published by [{name}], all
        rights reserved.
      copyRight2: >-
        Without written authorization, any unit or individual is prohibited from
        reprinting, excerpting, copying, or creating mirror images in any way.
        Violators will be held legally responsible.
      favorite: '{total} favorites'
      like: '{total} likes'
      preview: (Preview)
      previewTitle: Preview News
      public: '{date} Published'
      read: '{view} reads'
      sidePanel:
        favorite: Favorite
        like: Like
      title: News
      view: '{total} views'
    organization:
      empty: No organization description available
      title: Organization
    repository:
      empty: No repository description available
      title: Repositories
    template3:
      journalism:
        collect: '{favorites} favorites'
        like: '{like} likes'
        read: '{view} reads'
  footer:
    content: >-
      ©{year} Copyright © OpenAtom Foundation. All rights reserved. J. ICP B.
      No. 2020036654-1policeJ.G.W.A.B. No. 11030102011597
  home:
    column:
      title: Column
    communityCard:
      join: Join community
      joined: Joined
      people: members
    communityData:
      organization:
        title: Organizations
        total: Organizations
      people:
        title: Members
        total: Members
      repository:
        title: Repositories
        total: Repositories
    datacard:
      fork: Total Forks
      pr: Total PRs
      repos: Repositories Included
      stars: Total Stars
      title: Community Achievements
    developer:
      more: View More
      title: Trending Developer
    event:
      detail: View Detail
      status1: Effective
      status2: Pending
      status3: Ineffective
      time: long-term activities
      title: Event Calendar
    footer:
      content: >-
        ©{year} Copyright © OpenAtom Foundation. All rights reserved. J. ICP B.
        No. 2020036654-1policeJ.G.W.A.B. No. 11030102011597
      subscription:
        field1:
          error: Search for name
          title: Name
        field2:
          error: Email must be formatted correctly.
          title: Email
        subscribe: Subscribe
        success:
          content: >-
            Thanks for submitting the form. You have been added to the
            subscriber list.
          title: Successful
        title: Subscribe Our Newsletter
    organization:
      more: View More
      title: Trending Organization
    recommend:
      organization:
        empty: No organization description available
      repository:
        empty: No repository description available
    repository:
      more: View More
      title: Trending Repository
    sidebar:
      email: Email
      feedback: FB
      link: CT
      tel: Telephone
      wechat: Scan to follow
    template3:
      footer:
        title1: Help Documentation
        title2: Privacy Policy
        title3: Terms of Service
      home: View Home
      login: Log In
      notice1: Good Morning!
      notice2: Good Afternoon!
      notice3: Good Afternoon!
      notice4: Good Evening!
      prime: Pinned
      type1: News
      type2: Organization
      type3: Repository
      welcome: Welcome to {communityName}
  hot:
    follow: Follow
    followed: Following
    title1: Excellent Developer
    title2: Popular Repository
    title3: Pinned Organization
    title4: Column
    title5: Selected News
  search:
    hotTag:
      title: Hot Tag
    index:
      title: Search Result
    inputPlaceholder: What are you searching for…?
    journalism:
      title: Journalism
    order:
      fork: Fork
      hottest: Hottest
      member: Member
      newest: Newest
      star: Star
    organization:
      title: Organization
    repository:
      title: Repository
    searchResult: '{total} Results'
    tag:
      number1: '{total} Journalism'
      number2: '{total} Repository'
      number3: '{total} Organization'
      title: Tag
  subscription:
    subscribe:
      success:
        title: Success
    unsubscribe:
      button: Unsubscribe
      content: >-
        Your email address {email} has been removed from the subscription list.
        You will no longer receive information from {title}. You can
        re-subscribe at any time or subscribe using another email address.
      resubscribe: Resubscribe
      success:
        content: >-
          We regret that you have decided to unsubscribe, but we appreciate your
          support over the years. We are committed to providing quality content
          for our users, but we understand your needs and choices. If you need
          to, you can {resubscribe} to our service at any time.
        title: Success
      thanks: Thank you!
      title: Unsubscribe
  tag:
    index:
      title: Tag
    journalism:
      title: Journalism
    organization:
      title: Organization
    repository:
      title: Repository
  websiteDescription:
    default: Description
  websiteKeywords:
    default: Keywords
mobile:
  '404':
    goBack: Back
    notFound: Page Not Found
  column:
    all: View more
    index:
      infoTotal: 'Total: {total}'
      like: 'Like: {total}'
      title: Column
      view: 'View: {total}'
    title: Column
  common:
    all: All
    carousel:
      changeTo: Switch to pictures {index}
      jumpToUrl: Jump to {url}
    emptyContent: No Data
    follow:
      cancel: Unfollow
      ok: Follow
    nodata: '—— No more content —— '
    prime: Pinned
  component:
    noticeBar:
      close: ''
    pagination:
      goto: ''
      ok: ''
    popconfirm:
      cancel: ''
      ok: ''
  content:
    title1: Trending
    title2: News
    title3: Org
    title4: Rep
    title5: Developer
  footer:
    content: >-
      ©{year} Copyright © OpenAtom Foundation. All rights reserved. J. ICP B.
      No. 2020036654-1policeJ.G.W.A.B. No. 11030102011597
  home:
    communityCard:
      join: Join community
      joined: Joined
    detail:
      collect: favorites
      comment: comment
      like: like {like}
      read: '{view} reads'
    event:
      title: Event Calendar
    footer:
      contact: Contact us
      content: >-
        ©{year} Copyright © OpenAtom Foundation. All rights reserved. J. ICP B.
        No. 2020036654-1policeJ.G.W.A.B. No. 11030102011597
      help: Help
      title1: Help Documentation
      title2: Privacy Policy
      title3: Terms of Service
    join:
      join: Join Us
      title: Community
    journalism:
      collect: '{collect} favorites'
      like: '{like} likes'
      read: '{view} reads'
    recommend:
      developer:
        empty: No developer description available
      operation:
        title: Advertisement
      organization:
        empty: No organization description available
      repository:
        empty: No repository description available
    shareCard:
      copy: Copy Link
      copyed: Succeeded
      save: Save Image
      text1: Find all the {0} right here!
      text2: Welcome
      text3: 「Exciting content」
      text4: ' Scan the QR code to share.'
      text5: Explore the community
      text6: Everything for Developers
      title: Share
  hot:
    follow: Follow
    followed: Following
    title1: Excellent Developer
    title2: Popular Repository
    title3: Pinned Organization
  search:
    index:
      title: Search Result
  websiteDescription:
    default: Description
  websiteKeywords:
    default: Keywords
settings:
  '404':
    goBack: Back Home
    notFound: This page could not be found.
  action:
    add: New
    add1: Add
    addJournalism: New
    close: Close
    column1: Action
    delete: Delete
    downline: Unpublish
    edit: Edit
    editlimits: Edit
    goBack: Back
    look: View
    manage: Manage
    pinned: Pinned
    preview: Preview
    publish: Publish
    search: Search
    submit: Submit
    unpinned: Unpinned
    view: View
  component:
    dialog:
      button:
        cancel: Cancel
        close: Close
        ok: Ok
      defaultTitle: Dialog
      error: Error
      loading: Loading...
      refresh: Refresh
    markdownEditor:
      toolbar:
        fullscreen: Fullscreen
    richEditor:
      loading: Loading...
      plugins:
        markdownIt:
          title: Insert Markdown
    searchTable:
      buttonText: Search
      subTitle: Condition
    upload:
      button: Upload
  customContent:
    index:
      description: >-
        The custom content you edit will be displayed in the corresponding area
        on the homepage. Currently, only the legal template supports displaying
        custom content.
      form:
        label: Content
      switchButton:
        markdownEditor: Markdown Editor
        richEditor: Rich Text Editor
        switchTo: Switch to {editorType}
    switchEditor:
      cancel: Cancel
      content: Are you sure you want to switch editor? Current content will be cleared.
      contentWithText: >-
        Content detected! Switching editor will clear all existing content.
        Continue?
      ok: Confirm
      title: Switch Editor
  directive:
    confirm:
      modal:
        button:
          cancel: Cancel
          ok: Ok
        content: Are you sure you want to execute this operation?
        title: Confirm
  form:
    validation:
      email: This is not a valid email address
  menu:
    direction:
      column:
        detail:
          index: Column Detail
        index:
          add: Add Column
          edit: Edit Column
        listing:
          index: Column
      comment:
        index: Comment
      journalism:
        add: New
        edit: Editing News
        index: News Management
      organization:
        add: New
        application: Organization Application
        index: Organization Management
      repository:
        add: New
        application: Repository Application
        index: Repository Management
        listing: ''
      tag:
        add: New
        edit: Editing Tags
        index: Tag
      title: Content Manager
    home:
      title: Home
    operator:
      activityApplication:
        add: Add Application
        edit: Edit Application
        index: Activity Application
      banner:
        add: New
        edit: Edit
        index: Banner
      communityInfo: Information
      customContent:
        index: Custom Content
      email:
        add: New
        edit: Edit
        index: Template
      event:
        add: New
        edit: Edit
        index: Event Calendar
      notice:
        index: Notice
      operator:
        add: New
        edit: Edit
        index: Ad Space
      popupWindow:
        index: Custom Popup
      seo:
        edit: SEO Setting
      stats:
        index: Stats
      subscribe:
        history: History
        index: Mailing List
      title: Operation
      token:
        add: Add New AccessToken
        index: Access Token
      toolbar:
        index: Toolbar
    system:
      floatNavigation:
        index: Float Navigation
      homepage:
        index: Home
      people:
        index: Member
      title: Setting
  notification:
    del: Delete Success
    fileLarge: The file is too large. Please select a file smaller than {size}.
    networkError: 'Network Error! API: {url} ; Message: {msg}'
    notice1: Please select at least one user.
    notice2: Successfully added to the email sending queue.
    required: Required Field
    requiredSelect: Required
    success: Success
    upload:
      error: Upload Error!
      filenameError: An error occurred while retrieving the uploaded file name!
      illegal: You do not have permission to upload files!
      networkError: 'Network Error: {msg}'
      otherError: 'Error: {msg}'
      success: Upload Success!
    uploadRequired: Required
  table:
    column:
      action: Action
  token:
    column1: Token Name
    column2: Token Details
    column3: Expiration Time
    column4: Create Time
    column5: Expiration Time
    column6: Expiration Status
    date: '{day} days'
    desc: Generate tokens for access
    expired1: Expired
    expired2: Expires in {day} day(s)
    expired3: Expires in {month} month(s)
    expired4: Expires in {year} year(s)
    pop:
      desc: >-
        * The access token can only be visible once after it is successfully
        created. Please copy and save it in time
      title: Access token created successfully
  view:
    activityApplication:
      edit:
        column1: Applicant
        column10: Type
        column11: Technology Field
        column12: Competition Name
        column13: Competition Description
        column14: Historical Experience
        column15: Acquired Support
        column2: Contact
        column3: Email
        column4: Address
        column5: Work Unit
        column6: Job
        column7: WeChat ID
        column8: School
        column9: Platform
      index:
        column1: Applicant
        column10: Action
        column2: Contact
        column3: Email
        column4: Address
        column5: Work Unit
        column6: Job
        column7: WeChat ID
        column8: School
        column9: Platform
        header1: Keywords
        status:
          '0': Pending
          '1': Approved
          '2': Rejected
          all: All
        statusSelect: Status
      platformOptions:
        campus: Campus
        competition: Competition
      statusOptions:
        approved: Approved
        pending: Pending
        rejected: Rejected
      typeOptions:
        competition: Competition
    banner:
      index:
        column1: Name
        column3: Banner
    column:
      detail:
        add:
          column1: Name
          placeholder1: Select/Search
          title: Add
        index:
          author: Author
          collection: Collection
          column: Column
          introduce: Introduction
          like: Like
          time: Time
          view: View
      listing:
        add:
          colum1: Name
          colum2: Description
          colum3: Cover
          colum4: Sort
          colum5: Mobile Cover
          tips1: ''
        index:
          column: Column
          cover: Cover
          operate: Action
          order: Order
          quantity: Quantity
          state: State
          status:
            '0': All
            '1': Published
            '2': Offline
          time: Time
    comment:
      index:
        comments: Comments
        del: Delete
        hide: Hide
        notification:
          del: Delete Success
          success: Success
        operate: Action
        reviewArticle: Review Article
        show: Show
        time: Time
        title: Title
        user: User
    event:
      edit:
        button: The default button text is "Learn More"
        colum1: Title
        colum10: description
        colum2: Style
        colum3: Event Image
        colum4: Button
        colum5: URL
        colum6: Sort
        colum7: Type
        colum8: Time
        colum9: Location
        help: Image size： 240x144 pixels.
        notice: Your configured event title will be displayed here.
        type1: Template
        type2: 'User Defined '
    floatNavigation:
      edit:
        title1: Telephone
        title2: Email
        title3: Feedback
        title4: WeChat
      index:
        column1: Icon
        column2: Type
        column3: Content
        column4: Link
        column5: Status
        column6: Action
    general:
      add: New
      addFooter:
        column1: Content
      addMedium:
        column1: Name
        column2: URL
        column3: Image
      addfooter: New Footer
      addmedium: New
      column1: Community Name
      column2: Community Description
      column4: Main Logo
      column5: LOGO
      column6: WeChat
      column7: Media
      editfooter: Edit Footer
      editmedium: Edit
      help4: 'Image Size: 280x72'
      help5: 'Image Size: 128x128'
      help6: Please upload the QR code for your WeChat Official Account.
    homepage:
      column1: Banner
      column10: Hotlist
      column11: Column
      column12: Journalism
      column13: Events
      column14: Selected News
      column15: Custom Content
      column16: Hot Tag
      column17: Community Achievements
      column2: Pinned
      column3: Community Data
      column4: Activity
      column5: Trending Repositories
      column6: Trending Organization
      column7: Trending Developers
      column8: Recommend
      column9: Community Card
      edit: Edit
      module: (Currently)
      templateAlert: >-
        Note: Template switches will only take effect after clicking "Use" or
        "Edit". After clicking "Use" or "Edit", the switch states of other
        templates will be restored to default.
      use: Use
    journalism:
      add:
        column1: Title
        column2: Description
        column3: Image
        column4: Tag
        column5: Content
        column6: Keywords
        column7: Publish Time
        draft: Draft
        help3: 'Image Size: 864x416'
        help4: Select up to 5 tags
        help6: Multiple keywords separated by commas.
        placeholder1: Select/Search
        selectColumns: Select Column
      index:
        action1: Reject
        all: All
        column1: Name
        column2: Tag
        column3: Cover
        column4: Update Time
        column5: Author
        column6: Status
        column7: Action
        header1: Keywords
        header2: Update Time
        header3: Pinned
        included: Included
        includedColumns: Included in Column
        notpass: Rejected
        pass: Approved
        refuse: Reject
        status:
          '1': Published
          '2': Draft
          '3': Unpublished
          '4': Pending
        type:
          '1': Pinned
          '2': Unpinned
      rejectWindow:
        column: Title
        refuse: Reason
    notice:
      add: Add Notice
      content: Notice Content
      createTime: Create Time
      edit: Edit Notice
      endTime: End Time
      jumpLink: Jump Link
      'no': 'No'
      releaseTime: Release Time
      timedRelease: Timed Release
      title: Notice Title
      validity: Validity
      'yes': 'Yes'
    operation:
      edit:
        colum1: Title
        colum2: Image
        colum3: URL
        colum4: Sort
        colum5: Type
        colum6: Time
        column1: Name
        column2: Image
        column3: URL
        column4: Order
        column5: Type
        column6: Activity Time
        status:
          '1': Short-term
          '2': Long-term
        tips1: >-
          To achieve better display quality, we recommend uploading an image
          with dimensions of 1920x320 pixels (with effective content within 1200
          pixels).
        tips2: Image size： 360x180 pixels.
      index:
        column1: Name
        column2: URL
        column3: Image
        column4: Activity Time
        column5: Order
        column7: Action
        status:
          '0': All
          '1': Effective
          '2': Pending
          '3': Ineffective
          '4': Long-term
          '5': Offline
    organization:
      add:
        button: Back
      application:
        action:
          editLabel: Edit Tag
          notFeatured: Unpinned
          selected: Pinned
          unbinding: Unbind
        agree: Approve
        all: All
        applicant: Applicant
        briefIntroduction: Description
        column: Name
        column1: ''
        column2: ''
        column3: Tag
        linkTime: Date
        notFeatured: Unpinned
        operate: ''
        refuse: Reject
        refuse1: Reject
        selected: Pinned
        time: Date
      dialog:
        label:
          column1: Tag
          help1: Select up to 5 tags
      index:
        add: New
        application: Application
        column1: Name
        column2: Introduction
        column3: Repositories
        column4: Action
        listing: Organization
      rejectWindow:
        column: Name
        refuse: Reason
    people:
      edit:
        column1: Nickname
        column2: Account
        column3: Permissions
        column4: Role
        status:
          '1': Member
          '2': Super Admin
          '3': Admin
      index:
        all: All
        button:
          add: New
        column1: Avatar
        column2: Nickname
        column3: Account
        column4: Join Time
        column5: Permissions
        column6: Action
        header1: Keywords
        header2: Join Time
        status:
          '1': Super Admin
          '2': Admin
          '3': Member
        title1: Edit
        type:
          '1': Pinned
          '2': Unpinned
    popupWindow:
      column1: Popup Type
      column2: Popup Image
      column3: Popup Title
      column4: Popup Description
      column5: Promotional Copy
      column6: Redirect Link
      help1: >-
        For better visual effect, it is recommended to upload an image with
        dimensions of 600x208 and size not exceeding 2MB
      preview: Effect Display
      title1: Join Us
      title2: Customize
      title3: Close
    repository:
      add:
        button: Back
      application:
        action:
          editLabel: Edit Tag
          notFeatured: Unpinned
          selected: Pinned
          unbinding: Unbind
        agree: Approve
        all: All
        applicant: Applicant
        briefIntroduction: Description
        column: Name
        column1: Star
        column2: Fork
        column3: Tag
        linkTime: Date
        notFeatured: Unpinned
        operate: ''
        refuse: Reject
        refuse1: Reject
        reset: ''
        selected: Pinned
        time: Date
      dialog:
        label:
          column1: Tag
          help1: Select up to 5 tags
          title: Edit Tag
      index:
        add: New
        application: Application
        column1: Name
        column2: Introduction
        column3: Star
        column4: Fork
        column5: Action
        listing: Repository
      listing:
        applicant: Applicant
        briefIntroduction: Description
        column: Name
        operate: Operation
        reset: Reset
        time: Time
      rejectWindow:
        column: Name
        refuse: Reason
    seo:
      description: Description
      keywords: Keywords
      keywordsHelp: Multiple keywords separated by commas.
      robots: robots.txt
      title: Title
    stats:
      baidu:
        help:
          '1': To get "Baidu Stats ID", please refer to this {component}.
          '2': >-
            "Baidu Stats ID" is a 32-digit alphanumeric string, such as
            "3388ff634a74c1cd4fd62172cddf2b2d".
          '3': Documentation
        id: Baidu Stats ID
    subscription:
      template:
        edit:
          button: Back
          help: Markdown
        index:
          column1: Template
          column2: Creator
          column3: Subject
          column4: Create Time
          column5: Action
          column6: Content
      user:
        history:
          action: Recipient
          button1: Refresh
          column1: Subject
          column2: Send Time
          column3: Operator
          column4: Action
        index:
          button1: Send
          button2: History
          column1: Search
          column2: Subscription Period
          column3: Name
          column4: Email
          column5: Action
          condition1: Selected
          condition2: All
        listing:
          title: Recipient
        preview:
          button: Close
          title: View
        template:
          column1: Template
          column2: Subject
          notice1: Select Template
          status1: Confirm
          status2: Cancel
          title: Select
        view:
          title: View
        window:
          column1: Name
          column2: Email
          notice: >-
            Once the email is sent, it cannot be recalled. Please double-check
            the information to ensure its accuracy!
          status1: Confirm
          status2: Cancel
          title: Confirmation
    tag:
      index:
        button:
          add: New
        column1: Name
        column2: Order
        column3: Status
        column4: Created Time
        column5: Action
        header2: Created Time
        title1: New
        title2: Edit
    toolbar:
      index:
        action1: Add Sub Navigation
        column1: Title
        column2: URL
        column3: Order
        column4: Action
        column5: English Title
        column6: Type
        column7: Tag/Column Name
        column8: English Title
        header1: Title
        title1: New Navigation
        title2: Edit Navigation
        type1: Link
        type2: Tag
        type3: Column
        type4: Parent Navigation
    welcome:
      data:
        count: ''
        members: Member Count
        organization: Organization Count
        repository: Repository Count
      general:
        column1: PV
        column2: UV
        column3: New Members
        column4: Active Members
        column5: New Repositories
        column6: New Organizations
        column7: New Commits
        column8: New Issue
        column9: New CR
        title: Core Data
      overview:
        organization: New Organizations
        pv: PV
        repository: New Repositories
        title: Overview
        user: Active Members
      save: Download
      welcome: Welcome!
  websiteTitle:
    default: Setting
